import { useEffect } from "react";
import { parseScriptTags } from "../helpers/seo_helper";

const FooterScriptsPortal = ({ analytics }) => {
  const decodeBase64 = (str) => (str ? atob(str) : "");

  useEffect(() => {
    const footerScripts = Object.keys(analytics)
      .filter((key) => analytics[key].enabled && analytics[key].footer?.script)
      .map((key) => decodeBase64(analytics[key].footer.script));

    // Create and append each script
    const appendedScripts = footerScripts.flatMap((code) => {
      const scripts = parseScriptTags(code);
      return scripts.map((scriptData) => {
        const el = document.createElement("script");
        el.type = "text/javascript";

        // Set attributes
        if (scriptData.props.async) el.async = true;
        if (scriptData.props.defer) el.defer = true;
        if (scriptData.props.src) el.src = scriptData.props.src;

        // Add inline JS if no src
        if (!scriptData.props.src) {
          el.textContent = scriptData.content;
        }

        document.body.appendChild(el);
        return el;
      });
    });

    // Cleanup on unmount
    return () => appendedScripts.forEach((el) => el.remove());
  }, [analytics]);

  return null; // Nothing to render
};

export default FooterScriptsPortal;